export const baseUrl = 'https://json.mycouncilstory.com.au';
export const defaultYear = '2018-19';



// WEBPACK FOOTER //
// ./src/constants/ApiSettings.ts